var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMewinNewLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 17,
    viewBox: "0 0 84 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8766 0.151999V17H15.7726V6.896L12.0046 17H8.69259L4.90059 6.872V17H0.796594V0.151999H5.64459L10.3726 11.816L15.0526 0.151999H19.8766ZM26.9318 3.44V6.848H32.4278V10.016H26.9318V13.712H33.1478V17H22.8278V0.151999H33.1478V3.44H26.9318Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.9962 0.151999L54.6042 17H49.6362L46.9482 5.912L44.1642 17H39.1962L34.9242 0.151999H39.3162L41.7402 12.416L44.7402 0.151999H49.2522L52.1322 12.416L54.5802 0.151999H58.9962ZM65.1584 0.151999V17H61.0544V0.151999H65.1584ZM83.2045 17H79.1005L72.2365 6.608V17H68.1325V0.151999H72.2365L79.1005 10.592V0.151999H83.2045V17Z",
    fill: "#FFC12E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMewinNewLogo);
export default __webpack_public_path__ + "static/media/MEWIN_new_logo.ee0909aaba7b58d7951ff66df6d11e32.svg";
export { ForwardRef as ReactComponent };